import React from 'react'
import moment from 'moment'
const { useMemo, useCallback } = React

const Agenda = ({ events, currentDate, onSelectEvent, onNavigate }) => {
  const groupedEvents = useMemo(() => {
    const now = moment(currentDate).startOf('month');
    const thirtyDaysLater = moment(currentDate).endOf('month');
    
    const filteredEvents = events.filter(event => {
      const eventDate = moment(event.start);
      return eventDate.isBetween(now, thirtyDaysLater, 'day', '[]');
    });

    return filteredEvents.reduce((groups, event) => {
      const date = moment(event.start).format('YYYY-MM-DD');
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(event);
      return groups;
    }, {});
  }, [events, currentDate]);

    const [expandedEvents, setExpandedEvents] = useState({})

  const handleSelectEvent = useCallback((event) => {
    const pathParts = window.location.pathname.split('/');
    const calendarIndex = pathParts.indexOf('calendar');
    if (calendarIndex !== -1) {
      pathParts.splice(calendarIndex, 1, 'programs', event.programId, 'events', event.eventId);
    }
    const newPath = pathParts.join('/');
    window.open(`${window.location.origin}${newPath}`, "_blank");
  }, [])

  // Navigation handlers
  const goToPrevious = () => {
    const newDate = moment(currentDate).subtract(1, 'month').startOf('month').toDate();
    onNavigate(newDate);
  };

  const goToNext = () => {
    const newDate = moment(currentDate).add(1, 'month').startOf('month').toDate();
    onNavigate(newDate);
  };

  const goToToday = () => {
    onNavigate(new Date());
  };

  // Toggle event details visibility
  const toggleDetails = (eventId) => {
    setExpandedEvents(prev => ({
      ...prev,
      [eventId]: !prev[eventId]
    }));
  }

  return (
    <div style={{ height: 600, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      {/* Navigation Toolbar */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        padding: '0px',
        marginBottom: '10px'
      }}>
        <div style={{ display: 'flex', gap: '5px', flex: 1 }}>
          <button 
            onClick={goToPrevious}
            style={{ 
              padding: '5px 10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: 'white',
              cursor: 'pointer',
              flex: 1  // Add this
            }}
          >
            Back
          </button>
          <button 
            onClick={goToToday}
            style={{ 
              padding: '5px 10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: 'white',
              cursor: 'pointer',
              flex: 1  // Add this
            }}
          >
            <strong>Today</strong>
          </button>
          <button 
            onClick={goToNext}
            style={{ 
              padding: '5px 10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: 'white',
              cursor: 'pointer',
              flex: 1  // Add this
            }}
          >
            Next
          </button>
        </div>
      </div>

      {/* Scrollable Events Area */}
      <div style={{ flex: 1, overflow: 'auto' }}>
        {Object.entries(groupedEvents).map(([date, dayEvents]) => (
          <div key={date} style={{ marginBottom: '15px' }}>
            {/* Custom Date Header */}
            <div style={{ backgroundColor: '#3174ad', color: 'white', padding: '5px 10px 5px 10px', borderRadius: '4px 4px 0 0'}}>
              <h6 style={{ margin: 0, fontSize: '14px' }}> {moment(date).format('dddd, MMMM Do')}</h6>
            </div>
            
            {/* Custom Event Cards */}
            <div style={{ border: '1px solid #ddd', borderTop: 'none' }}>
              {dayEvents.map((event, index) => (
                <div key={event.id} style={{ padding: '10px 15px 10px 15px', borderBottom: index < dayEvents.length - 1 ? '1px solid #eee' : 'none',backgroundColor: index % 2 === 0 ? '#fafafa' : 'white', cursor: 'pointer' }}>
                  <h6 style={{ margin: '0px 0px -4px', fontWeight: 'bold', fontSize: '14px' }} title="Event Name" onClick={() => handleSelectEvent(event)} >
                    {event.title} <i style={{ fontSize: '16px', verticalAlign: 'text-top' }} className="material-icons">open_in_new</i>
                  </h6>
                  
                  <div>
                    {/* Column 1 */}
                    <div>
                      <div style={{ fontWeight: '400', color: '#1976d2', fontSize: '14px' }} title="Location">
                        {event.location}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }} title="Event Date">
                        {moment(event.start).isSame(event.end, 'day') 
                          ? `${moment(event.start).format('h:mmA')} - ${moment(event.end).format('h:mmA')}`
                          : `${moment(event.start).format('MM/DD h:mmA')} - ${moment(event.end).format('MM/DD h:mmA')}`
                        }
                      </div>

                      <div style={{ height: '28px' }}>
                        <p style={{ fontSize: '12px', marginBottom: '5px' }}>Details
                          <button
                            type="button"
                            className="mdl-button mdl-button--icon mdl-button--transparent mr-0"
                            onClick={() => toggleDetails(event.id)}
                            aria-label={expandedEvents[event.id] ? 'Hide details' : 'Show details'}
                            style={{
                              transform: expandedEvents[event.id] ? 'rotate(180deg)' : 'rotate(0deg)',
                              transition: 'transform 0.1s',
                              minWidth: '20px'
                            }}>
                            <i className="material-icons">expand_more</i>
                          </button>
                          </p>
                      </div>

                      {expandedEvents[event.id] && (
                        <div>
                          {event.instructors && event.instructors
                            .filter(instructor => instructor.is_primary)
                            .map(instructor => (
                              <p style={{ fontSize: '12px', marginBottom: '0px' }} title="Primary Instructor" >
                                <strong>Primary Instructor:</strong> {instructor.first_name} {instructor.last_name}
                              </p>
                            ))
                          }
                          <p style={{ fontSize: '12px', marginBottom: '0px' }} title="Enrollment" ><strong>Enrollment: </strong>{ event.event_registrations_count }</p>
                          {event.program && (
                            <p style={{ fontSize: '12px', marginBottom: '0px' }} title="Program" >
                              <strong>Program:</strong> {event.program}
                            </p>
                          )}
                          {event.region && (
                            <p style={{ fontSize: '12px', marginBottom: '0px' }} title="Region" >
                              <strong>Region:</strong> {event.region}
                            </p>
                          )}
                          {event.county && (
                            <p style={{ fontSize: '12px', marginBottom: '0px' }} title="County" >
                              <strong>County:</strong> {event.county} County
                            </p>
                          )}
                          <p style={{ fontSize: '12px', marginBottom: '0px' }} title="Handicap Accessible" ><strong>Handicap Accessible:</strong>{ event.handicapAccessible ? ' Yes' : ' No' }</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
        
        {Object.keys(groupedEvents).length === 0 && (
          <div style={{ 
            textAlign: 'center', 
            color: '#999', 
            marginTop: '50px',
            padding: '20px'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '10px' }}>&#128197;</div>
            <h4>No upcoming events</h4>
            <p>Check back later or adjust your filters</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Agenda
